import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Seo } from "@/components/Seo";
import { Hero } from "@/components/sections/Hero";
import { TechStack } from "@/components/sections/TechStack";
import { ServicesPreview } from "@/components/sections/ServicesPreview";
import { WhyHBT } from "@/components/sections/WhyHBT";
import { TrainingTeaser } from "@/components/sections/TrainingTeaser";
import { CTA } from "@/components/sections/CTA";

export default function Home() {
  return (
    // Root styles from the redesign mockup. overflow-x is "clip" rather than
    // "hidden" so the sticky navbar still sticks to the viewport.
    <div style={{ fontFamily: "'IBM Plex Sans', 'Helvetica Neue', sans-serif", color: "#E8ECF4", background: "#070B16", minHeight: "100vh", overflowX: "clip" }}>
      <Seo
        title="Software Development & IT Services Company"
        description="Software development and IT services company — web and mobile apps, dedicated developers, IT consulting and cloud, plus HR and payroll for growing businesses."
        keywords={[
          "software development and IT services company",
          "custom web application development company",
          "web and mobile app development company",
          "hire dedicated software developers",
          "software development and IT outsourcing services",
          "software development training in Nagercoil",
        ]}
        path="/"
      />
      <Navbar />

      <main>
        <Hero />
        <TechStack />
        <ServicesPreview />
        <WhyHBT />
        <TrainingTeaser />
        <CTA
          title="Ready to Talk?"
          description="Tell us about your hiring or project requirement and we'll get back to you with next steps."
        />
      </main>

      <Footer />
    </div>
  );
}
